import { Card, CardContent, CardHeader, CardTitle } from '../../../../ui/common-ui/card';
import { Policy } from '../../types/policies';
import { Shield, Zap, CheckCircle, AlertTriangle } from 'lucide-react';
import { getPolicyCommands, normalizePolicySeverity } from '../../lib/policyTransforms';

interface PolicyStatsProps {
  policies: Policy[];
}

export const PolicyStats = ({ policies }: PolicyStatsProps) => {
  const stats = {
    total: policies.length,
    active: policies.filter(p => p.policyStatus === 'ACTIVE' || p.policyStatus === 'ENABLING').length,
    critical: policies.filter(p => normalizePolicySeverity(p.severity) === 'Critical').length,
    high: policies.filter(p => normalizePolicySeverity(p.severity) === 'High').length,
    actions: policies.reduce((acc, p) => acc + getPolicyCommands(p.policyEnableData).length, 0),
  };

  const statCards = [
    {
      title: 'Total Policies',
      value: stats.total,
      icon: Shield,
      className: 'text-primary',
    },
    {
      title: 'Enabled',
      value: stats.active,
      icon: CheckCircle,
      className: 'text-green-500',
    },
    {
      title: 'Critical',
      value: stats.critical,
      icon: AlertTriangle,
      className: 'text-red-500',
    },
    {
      title: 'High',
      value: stats.high,
      icon: AlertTriangle,
      className: 'text-orange-500',
    },
    {
      title: 'Total Actions',
      value: stats.actions,
      icon: Zap,
      className: 'text-yellow-500',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
      {statCards.map((stat) => {
        const Icon = stat.icon;
        return (
          <Card
            key={stat.title}
            className="rounded-2xl bg-card border-border/50 shadow-lg shadow-sky-500/5 hover:shadow-[0_4px_16px_hsl(var(--primary)/0.06)] hover:border-primary/30 transition-all duration-300 hover:-translate-y-px"
          >
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium text-muted-foreground">
                {stat.title}
              </CardTitle>
              <Icon className={`h-4 w-4 ${stat.className}`} />
            </CardHeader>
            <CardContent>
              <div className={`text-2xl font-bold ${stat.className}`}>
                {stat.value}
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
